import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '@/components/Logo';

export function AuthShell({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: string;
  children?: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="container-page flex min-h-[70vh] flex-col items-center justify-center py-12">
      <Link to="/" className="mb-8" aria-label="BingeBox home">
        <Logo size={30} />
      </Link>
      <div className="card w-full max-w-md p-8">
        <h1 className="font-display text-2xl font-bold text-ink">{title}</h1>
        {subtitle && <p className="mt-2 text-sm text-ink-muted">{subtitle}</p>}
        {children && <div className="mt-6">{children}</div>}
      </div>
      {footer && <div className="mt-6 text-sm text-ink-muted">{footer}</div>}
    </div>
  );
}

export function PhaseNote({ phase }: { phase: string }) {
  return (
    <div className="rounded-xl border border-border bg-surface-raised px-4 py-3 text-sm text-ink-muted">
      <span className="inline-flex items-center gap-2">
        <span className="h-1.5 w-1.5 rounded-full bg-brand" />
        Sign-in &amp; accounts go live in {phase}.
      </span>
    </div>
  );
}
